import { Component, OnInit, Inject, forwardRef, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, MatSnackBar } from '@angular/material';
import { ApiHandlerService } from '../services/api-handler/api-handler.service';
import { NgRedux } from '@angular-redux/store';
import { AppState } from '../../store/state.model';
import { SpinnerRef } from '../../common/components/spinner/overlay-ref.service';
import { SpinnerService } from '../../common/components/spinner/overlay-spinner.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FileDispatcher } from '../../store/file/file-dispatcher';
import { DialogBoxComponent } from '../../common/components/dialog-box/dialog-box.component';
import { ViewPackageControl } from '../common/presenter/view-package.presenter';
import { TranslationService } from '../../common/services/languages/translation.service';
import { ResponseColumnsASI, ResponseColumnsASIV2 } from '../common/presenter/view.model';
import { CommonDispatcher } from '../../store/common/common-dispatcher';
import { ViewFailedRecordsControl } from '../common/presenter/view-failedrecords.presenter';
import { SelectionModel } from '@angular/cdk/collections';
import { ASIControl } from '../upload-dialog/presenter/asi.presenter';
import { ViewASIControl } from '../common/presenter/view-asi.presenter';
import { PACKAGEControl } from '../upload-dialog/presenter/package.presenter';
import { asiColumns } from '../upload-dialog/presenter/asi.model';
import { ConfirmationBarComponent } from '../confirmation-bar/confirmation-bar.component';
import { environment } from '../../../environments/environment';
import { MatDivider } from '@angular/material/divider';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatCard } from '@angular/material/card';
import { MatPrefix } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { NgIf, NgFor } from '@angular/common';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatSort as MatSort_1, MatSortHeader } from '@angular/material/sort';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatPaginator as MatPaginator_1 } from '@angular/material/paginator';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-show-result',
    templateUrl: './show-result.component.html',
    styleUrls: ['./show-result.component.scss'],
    imports: [MatDivider, MatIconButton, MatIcon, MatCard, MatPrefix, MatInput, NgIf, MatButton, MatTable, MatSort_1, NgFor, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCheckbox, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator_1, TranslatePipe]
})
/** this component retrieves the status of the VIN in a table */
export class ShowResultComponent implements OnInit {
  /**
   * @arg parsed_data of type CapabilitiesHeaders/Package headers that holds the data of capabilities/packages.
   **/
  public parsed_data: Array<any>;
  /**
   * @arg tableDataSource of type any holds the capabilities/packages data.
   **/
  public tableDataSource: any;
  /**
   * @arg displayedColumns holds the list of headers for capabilities data.
   **/
  public displayedColumns: Array<string | number>;
  /**
   *@arg spinnerRef declaration of spinner Ref
   **/
  public spinnerRef: SpinnerRef;
  /**
   *@arg fileName file name from the redux
   **/
  public fileName: string;
  /**
   *@arg fileType file type from the redux
   **/
  public fileType: string;
  /**
 *@arg packageRequest the upload api payload from redux
 **/
  public packageRequest: any;
  /**
   *@arg tableData the tabledata from redux
   **/
  public tableData: any;
  /**
  *@arg isSubmitted set the flag to hide the buttons
  **/
  public isSubmitted: boolean;
  /**
   * @arg model stores the capabilites state
   */
  public model: any;
  /**
   * @arg confirmationBar stores the confirmation snack
   */
  public confirmationBar: object;
  /**
   * @arg step step if upload or getasi
   */
  public step: string;
  /**
   * @arg paginator paginator
   */
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  /**
   * @arg sort sort
   */
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  /**
   * @arg availableRoles role if submitter reviewer or approver
   */
  public availableRoles: Array<string>;
  /**
   * @arg reviewApproved to store review type value
   */
  public reviewApproved: boolean;
  /**
  * @arg selection to store selected items
  */
  public selection: any;
  /**
  * @arg reviewAction to store review action such as approve or reject
  */
  public reviewAction: string;
    /**
  * @arg productIds to store prodctids response
  */
     public productIds: any;
  /**
   *@arg activePortal active portal stores whether it's svpp or svppv2 or admin or dealer-admin or navi
   **/
  public activePortal: string;
  /**
   *@arg fixedAsiColumns stores the fixed columns
   **/
    /**
   *@property Data binded to use in the component
   **/
   @Input() asiUploadGeneration: string;
  /**
   *Property to load dashboard event
   **/
  @Output() loadDashboard: EventEmitter<any> = new EventEmitter<any>();
  public fixedAsiColumns: Array<string>;
  constructor(@Inject(forwardRef(() => ApiHandlerService))
  public apiHandler: ApiHandlerService,
    public ngRedux: NgRedux<AppState>,
    public dispatcher: FileDispatcher,
    public spinner: SpinnerService,
    public router: Router,
    public dialog: MatDialog,
    private readonly snackBar: MatSnackBar,
    public commonDispatcher: CommonDispatcher,
    public translate: TranslationService,
    public route: ActivatedRoute
  ) {
  }
  /**
   * @function ngOnInit Method to Initializes the component and perform initial operations
   */
  ngOnInit(): void {
    const path = window.location.pathname;
    this.activePortal =
      path.indexOf('svppv2') > -1 ? 'svppv2' : 'svpp';
    const { file: { fileType, reviewApproved }, common: { step }, auth: { userAvailableRoles } } = this.ngRedux.getState();
    this.fileType = fileType;
    this.step = step;
    this.reviewApproved = reviewApproved;
    this.defaults();
    this.getRecords();
    this.availableRoles = userAvailableRoles;
  }
  /**
   * @method isUserApprover return if the logged in user is approver
   */
  public isUserApprover(): boolean {
    return !!this.availableRoles && (this.availableRoles.indexOf('APPROVER') > -1 || this.availableRoles.indexOf('ADMIN') > -1);
  }
  /**
   * @method getAsiModel returns the presenter for review or upload
   */
  getAsiModel(): ASIControl | ViewASIControl {
    const { file: { uploadedFiledata }, common: { getResponse } } = this.ngRedux.getState();
    if (this.step === 'upload') {
      return new ASIControl(uploadedFiledata, this.activePortal);
    } else {
      const control = new ViewASIControl(this.activePortal);
      control.setData(getResponse as Array<object>);
      return control;
    }
  }
    /**
   * @function getRecords gets products and asi
   * @arg control model to get the api info for products or asi
   * @arg requestType asi or products
   * @arg recordType approved or submitted
   */
     private getRecords(): void {
      const { generation } = this.ngRedux.getState().file;
      this.spinnerRef = this.spinner.open();
      this.apiHandler.getRequest(environment.ProductCatalog.apis.getPackage, { type: 'getproductids', params: { generation: generation } }).subscribe({
        next: (response) => {
          this.spinnerRef.close();
          this.productIds = response;
        },
        error: (error) => {
          this.errorResponse();
          this.spinnerRef.close();
        }
      }
      );
    }
  /**
  * @method getAsiModel returns the presenter for review or upload
  */
  private getProductModel(): PACKAGEControl | ViewFailedRecordsControl | ViewPackageControl {
    const { file: { uploadedFiledata }, common: { getFailedRecords, getResponse } } = this.ngRedux.getState();
    switch (this.step) {
      case 'submit-error':
        const control = new ViewFailedRecordsControl();
        control.setData(getFailedRecords as Array<object>);
        return control;
      case 'upload':
        return new PACKAGEControl(uploadedFiledata, this.activePortal);
      default:
        const viewControl = new ViewPackageControl(this.activePortal);
        viewControl.setData(getResponse as Array<object>);
        return viewControl;
    }
  }
  /**
   * @method defaults method will capture the filename and calls intialize method.
   */
  private defaults() {
    this.fixedAsiColumns = this.activePortal === 'svppv2' ? ResponseColumnsASIV2 : ResponseColumnsASI;
    if (!!this.fileType && !!this.step) {
      const { fileName } = this.ngRedux.getState().file;
      this.model = this.fileType === 'asi' ? this.getAsiModel() : this.getProductModel();
      this.fileName = this.step === 'upload' ? fileName :
        (this.fileType === 'asi' ? 'show-result.label.filename-asi' : 'show-result.label.filename-package');
      this.intializeTableData();
    }
    this.isSubmitted = false;
  }
  /**
   * @method intializeTableData method will intialize the table data.
   */
  private intializeTableData() {
    this.displayedColumns = this.model.getColumns(this.reviewApproved);
    this.tableData = this.model.getTableData();
    this.parsed_data = this.tableData;
    this.tableDataSource = new MatTableDataSource(this.parsed_data);
    this.selection = new SelectionModel<any>(true, []);
    if (this.tableDataSource) {
      this.tableDataSource.paginator = this.paginator;
      this.tableDataSource.sort = this.sort;
    }
  }
  /**
   * @method applyFilter method will take the filterValue and filter over the dataSourse.
   * @param string filterValue anyvalue
   */
  public applyFilter(filterValue: string) {
    this.tableDataSource.filter = filterValue.trim().toLowerCase();
    if (this.tableDataSource.paginator) {
      this.tableDataSource.paginator.firstPage();
    }
  }
  /**
   * @method submit calls upload api to send either the listed capabilities or packages.
   */
  public submit(): void {
    this.spinnerRef = this.spinner.open();
    if(this.asiUploadGeneration === '17CYPLUS') {
      this.apiHandler.postRequest(this.model.getEndpoint, this.model.getApiRequest(), this.model.getApiType)
      .subscribe({
        next: (response) => this.successResponse(response),
        error: () => this.errorResponse()
      }
      );
    }
    if(this.asiUploadGeneration === '21MM' || this.asiUploadGeneration === '24MM') {
      this.apiHandler.postRequest(this.model.getEndpoint, this.model.getApiRequest(this.productIds), this.model.getApiType)
        .subscribe({
        next: (response) => this.successResponse(response),
        error: () => this.errorResponse()
      }
        );
    } else {
      this.apiHandler.postRequest(this.model.getEndpoint, this.model.getApiRequest(), this.model.getApiType)
      .subscribe({
        next: (response) => this.successResponse(response),
        error: () => this.errorResponse()
      }
      );
    }
  }
  /**
    * @method proceedReview calls approve api to send either the listed capabilities or packages.
    * @arg reviewFlag should contains the approval or rejected related flag as string
    * @returns void
    */
  public proceedReview(reviewFlag: string): void {
    this.spinnerRef = this.spinner.open();
    if(this.asiUploadGeneration === '17CYPLUS') {
      this.apiHandler.putRequest(this.model.getReviewApiEndpoint,
        this.model.getApiRequest(reviewFlag, this.selection.selected),
        this.model.getApiType)
        .subscribe({
        next: () => this.reviewResponse(reviewFlag),
        error: () => this.errorResponse()
      }
        );
    }
    else { 
      this.apiHandler.putRequest(this.model.getReviewApiEndpoint,
        this.step === 'upload' && this.model.getApiType['type'] === 'asi' ? this.model.getApiRequest(this.productIds) : this.model.getApiRequest(reviewFlag, this.selection.selected),
        this.model.getApiType)
        .subscribe({
        next: () => this.reviewResponse(reviewFlag),
        error: () => this.errorResponse()
      }
        );
    }
  }
  /**
    * @method review calls openDialog to confirm either approve or reject records and call proceedReview if agree.
    * @arg reviewFlag should contains the approval or rejected related flag as string
    * @returns void
    */
  public review(reviewFlag: string): void {
    this.reviewAction = reviewFlag;
    this.openDialog();
  }
  /**
  * @method reviewResponse should call the confirmation dialog and stores submitFile flag to hide the buttons.
  * @arg reviewFlag should contains the approval or rejected related flag as string
  */
  public reviewResponse(reviewFlag: string) {
    this.dispatcher.submitFile(true);
    this.confirmationSnack(reviewFlag === 'APPROVED' ? 'review-approve' : 'review-reject', 'success');
    this.spinnerRef.close();
    this.isSubmitted = true;
  }
  /**
   * @method successResponse should call the confirmation dialog.
   */
  public successResponse(response) {
    this.fileType !== 'asi' ? this.productResponse(response) : this.confirmationSnack('submit', 'success');
    this.dispatcher.submitFile(true);
    this.spinnerRef.close();
    this.isSubmitted = true;
  }
  /**
   * @method productResponse should displays recieved payload
   * @param res The response payload from the api
   * @returns void
   */
  private productResponse(res: any): void {
    (res['payload'] === undefined || !!!res.payload.consolidatedFailures) ?
      this.confirmationSnack('submit', 'success') : this.productsRejected(res);
  }
  /**
   * @method productsRejected should displays recieved failed products
   * @param res The response payload from the products api
   * @returns void
   */
  private productsRejected(res: any): void {
    this.commonDispatcher.setStep('submit-error');
    this.openCommonSnack('rejected', 'failed');
    this.commonDispatcher.setFailedrecords(res.payload.consolidatedFailures);
    this.spinnerRef.close();
    this.ngOnInit();
  }
  /**
  * @method confirmationSnack should displays confirmation
  * @returns void
  */
  private confirmationSnack(data: string, classType: string): void {
    this.loadDashboard.emit();
    this.openCommonSnack(data, classType);
  }
  /**
   * @method errorResponse should call the spinner
   * @param error The error payload from the api
   * @returns void
   */
  public errorResponse(): void {
    this.router.navigate(['dashboard/svpp/dashboard_content'], { queryParams: {}, skipLocationChange: true });
    this.openCommonSnack('failed', 'failed');
    this.dispatcher.submitFile(false);
    this.spinnerRef.close();
  }

  /**
   * @method isSticky determine if cloumn is a sticky
   * @arg column name
   */
  public isSticky(column: string): boolean {
    return asiColumns.indexOf(column.trim()) > -1;
  }
  /**
   * @method isTrue determine if capability is Y
   * @arg value Y or N
   * @arg column name
   */
  public isTrue(value: string, column: string): boolean {
    value = !value ? '' : value.toString();
    return this.step === 'upload' ?
      !(asiColumns.indexOf(column.trim()) > -1) && (value.trim() === 'Y' || value.trim() === 'y') :
      !(this.fixedAsiColumns.indexOf(column.trim()) > -1) && (!!value && value.trim() === 'true');
  }
  /**
   * @method isFalse determine if capability is N
   * @arg value Y or N
   * @arg column name
   */
  public isFalse(value: string, column: string): boolean {
    value = !value ? '' : value.toString();
    return this.step === 'upload' ?
      !(asiColumns.indexOf(column.trim()) > -1) && !(value.trim() === 'Y' || value.trim() === 'y') :
      !(this.fixedAsiColumns.indexOf(column.trim()) > -1) && !(!!value && value.trim() === 'true');
  }
  /**
   * @method arrowBack will show the dialog box and route to the dash board if agreed to leave
   * @returns void
   */
  public arrowBack(): void {
    this.reviewAction = '';
    this.openDialog();
  }
  /**
   * @method openDialog will display a dialog box to go back to dashboard or confirmation dialog for approve or reject
   * @returns void
   */
  public openDialog(): void {
    const actionStep = !!this.reviewAction ? this.reviewAction === 'APPROVED' ? 'approve' : 'reject' : this.step;
    const dialogRef = this.dialog.open(DialogBoxComponent, {
      data: {
        type: `go-back-${actionStep}`
      },
      width: '35em',
      height: 'auto'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.proceedReview(this.reviewAction); }
    });
  }

  /**
  * @method openCommonSnack will display noification bar based on data type
  */
  public openCommonSnack(dataType: string, classType: string): void {
    this.snackBar.openFromComponent(ConfirmationBarComponent, {
      data: {
        type: dataType
      },
      duration: 6000,
      verticalPosition: 'top',
      panelClass: ['custom-confirmation', classType],
    });
  }
  /**
   * @method isAllSelected() determines whether the all rows were selected or not
   * @returns boolean
   */
  public isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.tableDataSource.data.length;
    return numSelected === numRows;
  }
  /**
   * @method masterToggle Selects all rows if they are not all selected; otherwise clear selection.
   * @returns void
   */
  public masterToggle(): void {
    this.isAllSelected() ?
      this.selection.clear() :
      this.tableDataSource.data.forEach(row =>
        this.selection.select(row));
  }
}
